module.exports = __webpack_public_path__ + "img/new-report.20bb0b3b.svg";